import React from "react";
import OtpInput from "./OtpInput";
import PhotoCapture from "./PhotoCapture";
import CodCollect from "./CodCollect";

export default function DeliveryStep({
  trip,
  verifyStep,
  setVerifyStep,
  otp,
  onOtpChange,
  onOtpKeyDown,
  onVerifyOtp,
  otpRefs,
  otpError,
  otpVerified,
  fileInputRef,
  photoPreview,
  onPhotoSelected,
  onTakePhoto,
  onRetakePhoto,
  onUploadPhoto,
  photoUploading,
  photoTaken,
  codAmount,
  onCodAmountChange,
  codMethod,
  onCodMethodChange,
  onRecordCod,
  codCollected,
  onCompleteDelivery,
  updating,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 flex items-center justify-between">
        <div>
          <span className="text-xs uppercase font-bold text-emerald-700">
            Verification Sub-flow
          </span>
          <p className="font-bold text-gray-900 text-sm mt-0.5">
            Complete Delivery Safeguards
          </p>
        </div>
        <div className="flex gap-1">
          {trip.delivery_otp && (
            <span
              className={`w-2.5 h-2.5 rounded-full ${
                otpVerified ? "bg-green-500" : "bg-gray-300"
              }`}
            />
          )}
          <span
            className={`w-2.5 h-2.5 rounded-full ${
              photoTaken ? "bg-green-500" : "bg-gray-300"
            }`}
          />
          {trip.cod_enabled && (
            <span
              className={`w-2.5 h-2.5 rounded-full ${
                codCollected ? "bg-green-500" : "bg-gray-300"
              }`}
            />
          )}
        </div>
      </div>

      {verifyStep === "otp" && (
        <OtpInput
          otp={otp}
          onChange={onOtpChange}
          onKeyDown={onOtpKeyDown}
          onVerify={onVerifyOtp}
          otpRefs={otpRefs}
          otpError={otpError}
          updating={updating}
        />
      )}

      {verifyStep === "photo" && (
        <PhotoCapture
          fileInputRef={fileInputRef}
          photoPreview={photoPreview}
          onPhotoSelected={onPhotoSelected}
          onTakePhoto={onTakePhoto}
          onRetakePhoto={onRetakePhoto}
          onUploadPhoto={onUploadPhoto}
          photoUploading={photoUploading}
        />
      )}

      {verifyStep === "cod" && (
        <CodCollect
          codAmount={codAmount}
          onCodAmountChange={onCodAmountChange}
          codMethod={codMethod}
          onCodMethodChange={onCodMethodChange}
          onRecordCod={onRecordCod}
          updating={updating}
          targetAmount={trip.cod_amount}
        />
      )}

      {verifyStep === "confirm" && (
        <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm text-center">
          <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto text-xl font-bold">
            ✓
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-lg">
              Verification Complete
            </h3>
            <p className="text-xs text-gray-500 mt-1">
              All delivery safeguards confirmed. Tap below to complete trip.
            </p>
          </div>

          <button
            onClick={onCompleteDelivery}
            disabled={updating}
            className="w-full py-4 rounded-2xl bg-green-600 text-white font-bold text-base hover:bg-green-700 active:scale-95 transition-all shadow-md shadow-green-600/20 disabled:opacity-50"
          >
            {updating ? "Completing..." : "COMPLETE DELIVERY"}
          </button>
        </div>
      )}
    </div>
  );
}
